import { Box, CircularProgress } from '@mui/material'

import useIdentityDocumentImage from './useIdentityDocumentImage'

type IdentityDocumentDisplayProps = {
  documentImageId: string
}

const IdentityDocumentDisplay = ({ documentImageId }: IdentityDocumentDisplayProps) => {
  const { data, isPending } = useIdentityDocumentImage(documentImageId)

  if (isPending) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  return (
    <Box
      component="img"
      src={data?.data.src}
      alt="Document"
      sx={{
        display: 'block',
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
      }}
    />
  )
}

export default IdentityDocumentDisplay
